import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Alert } from '../../../shared/alert.model';
import { ProfileSyncService } from '../../services/profile-sync.service';
import { Router } from '@angular/router';
import { TransactionService } from '../../services/transaction.service';
import { Transaction, TransactionStatusOptions } from '../../model/Transaction';
import { EventEmitterWithValueReturned, EventEmitterWithObservable } from '../../../shared/EventEmitterWithValueReturned';
import { MessageService } from '../../../shared/message.service';
import { MessageType } from '../../../shared/messageType';
import { finalize } from 'rxjs/operators';
import { getAlertMessage } from '../../../shared/api-loaders';
import { IIndexer, arrayToObject } from '../../../shared/app-util';

@Component({
    selector: 're-process-list',
    templateUrl: './process-list.component.html',
    styleUrls: ['./process-list.component.scss'],
    standalone: false
})
export class ProcessListComponent implements OnInit {

  constructor(private router: Router, private transactionService: TransactionService, private messageService: MessageService) { }

  columnsToIgnoreObject: IIndexer<string>= {};

  _columnsToIgnore = new Array<string>();
  @Input()
  set columnsToIgnore(value:string[]) {
    this._columnsToIgnore = value;
    this.columnsToIgnoreObject = arrayToObject(value);
  }
  get columnsToIgnore() {
    return this._columnsToIgnore;
  }



  alert: Alert;

  @Input()
  title: "";

  @Input()
  description: "";

  data: Transaction[]

  @Output()
  loaded = new EventEmitter<EventEmitterWithObservable>();
  @Output()
  downloadData = new EventEmitter<any>();

  load() {
    this.messageService.send(MessageType.ProcessingOn);

    let data = new EventEmitterWithObservable();
    this.loaded.emit(data);
    if (!data.ReturnValue)
      throw 'loaded event didnt get the ReturnValue observable';


    this.data = [];
    this.alert = null;

    data.ReturnValue.pipe(finalize(() => this.messageService.send(MessageType.ProcessingOff)))
      .subscribe(x => {
        this.data = x;
      }, e => this.alert = getAlertMessage(e));

  }

  hasErrors(status: Transaction) {
    if (status.status == TransactionStatusOptions.CompletedWithErrors)
      return true;
    if (status.status == TransactionStatusOptions.Failed)
      return true;

    return false;
  }

  getStatusText(status: string) {
    return this.transactionService.getStatusText(status);
  }



  ngOnInit(): void {
    this.load();
  }

  download(item: any): void {
    this.downloadData.emit(item);
  }

}
